import { TCommonData, TLayout, TWidgetProps } from '@libs/types';
import clsx from 'clsx';
import React, { CSSProperties } from 'react';
import { THorizontalLayoutOption } from '../../types/options';
import styles from './css/horizontalLayout.module.css';

export const HorizontalLayout: React.FC<TWidgetProps<TCommonData, THorizontalLayoutOption> & TLayout> = ({ widget, children, margin }) => {
    const alignment = widget.options?.alignment ?? 'start';
    const arrangement = widget.options?.arrangement ?? 'center';

    const classNames = clsx(styles.horizontalLayout, styles[`alignment-${alignment}`], styles[`arrangement-${arrangement}`]);

    const inlineStyles: CSSProperties = {};
    if (margin?.top !== undefined) inlineStyles.marginTop = margin.top;
    if (margin?.bottom !== undefined) inlineStyles.marginBottom = margin.bottom;
    if (margin?.left !== undefined) inlineStyles.paddingLeft = margin.left;
    if (margin?.right !== undefined) inlineStyles.paddingRight = margin.right;

    return (
        <div data-test={widget.uid} className={classNames} style={inlineStyles}>
            {children}
        </div>
    );
};
